import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import SummaryTextBox from '../../shared/summaryTextBox/summaryTextBox.component';

class JournalTable extends PureComponent {
  static propTypes = {
    calcResultsLog: PropTypes.arrayOf(
      PropTypes.shape({
        calcJobId: PropTypes.number,
        jobId: PropTypes.number,
        logEntities: PropTypes.string,
        logId: PropTypes.number,
        logText: PropTypes.string,
        logType: PropTypes.string,
        perfMonitor: PropTypes.string,
      })
    ),
  };

  render() {
    const { calcResultsLog } = this.props;

    const content = calcResultsLog
      .map(line => line.logText)
      .join('\n');

    return (
      <div className="journal-table">
        <SummaryTextBox content={content} />
      </div>
    );
  }
}

function mapStateToProps({ provision }) {
  return {
    calcResultsLog: provision.general.calcResultsLog,
  };
}

export default connect(mapStateToProps, null)(JournalTable);
